// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

import {
  CHANGE_OPEN_PANEL,
  CLEAR_PROJECT_SUMMARY,
  FETCH_PROJECT_ERROR,
  FETCH_PROJECT_SUCCESS,
  FETCHING_PROJECT,
  PROJECT_SUMMARY_MODAL_CLOSE,
  PROJECT_SUMMARY_MODAL_OPEN,
  UPDATE_COMPANIES,
  UPDATE_HIGHLIGHTED_PATHS,
  UPDATE_MODAL_MESSAGE,
  UPDATE_MODAL_ERROR,
  UPDATE_MODAL_PATH_SET,
  UPDATE_PATHS,
  UPDATE_PROJECT_FILTER,
  UPDATE_PROJECT_SETTINGS,
  UPDATE_PROJECT_SORT,
  UPDATE_VISIBLE_PATHS,
} from './types'

import initialState from './initialState'

const projectSummary = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_OPEN_PANEL :
      return state.merge(
        fromJS({
          openPanel: action.openPanel,
        })
      )

    case CLEAR_PROJECT_SUMMARY :
      // initialState is already an immutable Map
      return state.merge(initialState)

    case FETCH_PROJECT_ERROR :
      return state.merge(
        fromJS({
          isFetching: false,
          error: action.error,
        })
      )

    case FETCH_PROJECT_SUCCESS :
      return state.merge(
        fromJS({
          isFetching: false,
          ...action.projectMeta,
        })
      )

    case FETCHING_PROJECT :
      return state.merge(
        fromJS({
          isFetching: true,
          error: '',
        })
      )

    case PROJECT_SUMMARY_MODAL_CLOSE :
      return state.merge(
        fromJS({
          modalTemplate: '',
          modalError: '',
          modalMessage: '',
        })
      )

    case PROJECT_SUMMARY_MODAL_OPEN :
      return state.merge(
        fromJS({
          modalTemplate: action.modalTemplate,
          modalPathsSet: fromJS(action.modalPathsSet),
        })
      )

    case UPDATE_COMPANIES :
      return state.merge(
        fromJS({
          companies: fromJS(action.companies),
        })
      )

    case UPDATE_HIGHLIGHTED_PATHS :
      return state.merge(
        fromJS({
          highlightedPaths: action.highlightedPaths,
        })
      )

    case UPDATE_MODAL_ERROR :
      return state.merge(
        fromJS({
          modalError: action.error,
        })
      )

    case UPDATE_MODAL_MESSAGE :
      return state.merge(
        fromJS({
          modalMessage: action.modalMessage,
        })
      )

    case UPDATE_MODAL_PATH_SET :
      return state.merge(
        fromJS({
          highlightedPaths: action.highlightedPaths,
          modalPathsSet: action.modalPathsSet,
        })
      )

    case UPDATE_PATHS :
      return state.merge(
        fromJS({
          paths: action.paths,
        })
      )

    case UPDATE_PROJECT_FILTER :
      return state.merge(
        fromJS({
          filterInput: action.filterInput,
          filterSelect: action.filterSelect,
          filterCheckbox: action.filterCheckbox,
        })
      )

    case UPDATE_PROJECT_SETTINGS :
      return state.merge(
        fromJS(action.settings)
      )

    case UPDATE_PROJECT_SORT :
      return state.merge(
        fromJS({
          sortAsc: action.sortAsc,
          sortCol: action.sortCol,
        })
      )

    case UPDATE_VISIBLE_PATHS :
      return state.merge(
        fromJS({
          visiblePathIds: action.visiblePathIds,
        })
      )

    default :
      return state
  }
}

export default projectSummary
